import { FaEdit, FaTimes } from "react-icons/fa";
import { useState } from "react";
import CreateCategory from "./CreateCategory";
import { getStatusColor } from "../../Path/AppDashboard";

const CategoryEditRequest = ({ cityId, selectedCategoriesIds, deleteCategories, scrapers, close }) => {
    const [editCategory, setEditCategory] = useState();
    return <div className="flex flex-wrap gap-2">
        {selectedCategoriesIds?.map((services, index) => <div key={index} className="flex flex-row justify-between gap-2 items-start px-3 py-2 m-1 bg-white rounded-lg shadow text-left w-[250px] border border-gray-100">

            <div>
                <div className="flex flex-row gap-1">
                    <h6 className="text-sm font-semibold text-gray-800 text-left truncate overflow-hidden whitespace-nowrap w-[150px]">
                        {services?.name}
                    </h6>                                            <div className={`h-[10px] w-[10px] rounded-[50%] ${getStatusColor(services.statusId || 1)} self-center`}></div>
                </div>
                <p className="text-xs text-gray-500 truncate">{services?.serviceType?.name}</p>
            </div>
            <div className="flex space-x-2 self-center">
                <FaEdit
                    className="text-blue-600 hover:text-blue-800 cursor-pointer"
                    onClick={() => setEditCategory(services)}
                />
                <FaTimes
                    className="text-red-500 hover:text-red-700 cursor-pointer"
                    onClick={() => deleteCategories(services.id)}
                />
            </div>
        </div>)}
        {editCategory?.id && <CreateCategory cityId={cityId} isOpen={editCategory?.id} isEdit={true} categoryData={editCategory}
            close={(refetchCategories) => {
                setEditCategory();
                if (refetchCategories) {
                    close(true);
                }
            }} scrapers={scrapers} />}
    </div>
};
export default CategoryEditRequest;
